/*eslint-disable*/ export const messages = { New: "Nuovo", "Remove {label}": ["Rimuovi ", ["label"]] };
